import Common from "../../../../Common";
import CallRouting from "./profile/CallRouting";
import Cid from "./profile/Cid";
import Queue from "./profile/Queue";
import TriggerWord from "./profile/TriggerWord";

interface CreateBody {
	name: string
	priority: number
	pbx_color_id: id
	pbx_icon_id: id
	profile_number: number
}

const Profile = class extends Common {
	callRouting: InstanceType<typeof CallRouting>;
	cid: InstanceType<typeof Cid>;
	triggerWord: InstanceType<typeof TriggerWord>;
	queue: InstanceType<typeof Queue>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.callRouting = new CallRouting(headers);
		this.cid = new Cid(headers);
		this.triggerWord = new TriggerWord(headers);
		this.queue = new Queue(headers);
	}

	browse = (companyId: id, profileTemplateId: id) =>
		this.get(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile`)

	read = (companyId: id, profileTemplateId: id, id: id) =>
		this.get(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${id}`)

	create = (companyId: id, profileTemplateId: id, body: CreateBody) =>
		this.post(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile`, body)

	update = (companyId: id, profileTemplateId: id, profileTemplateProfileId: id, body: CreateBody) =>
		this.patch(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}`, body)

	delete = (companyId: id, profileTemplateId: id, profileTemplateProfileId: id) =>
		this.doDelete(`/company/${companyId}/templates/profiles/${profileTemplateId}/profile/${profileTemplateProfileId}`)
}

export default Profile
